import LoadingIndicator from "~/common/components/LoadingIndicator";
import loadable from "~/utils/loadable";

export default loadable(() => import("./EventsView"), {
  fallback: <LoadingIndicator />
});
